"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _lodash = _interopRequireDefault(require("lodash"));

var _CreatedReviewOfProductComponent = _interopRequireDefault(require("./CreatedReviewOfProductComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * We create out class by using injectToBaseContainer
 * this will return a React Component that is wrapped with the HOCs
 * inside flowRight, and hass all the props that are passed as options
 */
var _default = (0, _BaseInjectors.injectToBaseContainer)(_lodash.default.flowRight(_reactRouterDom.withRouter, (0, _reactRedux.connect)(function (state) {
  return {
    products: state.productReviewsReducer.reviews
  };
})), {
  listComponent: _CreatedReviewOfProductComponent.default,
  headerTitle: 'Mes avis publiés',
  headerIcon: 'thumb_up'
});

exports.default = _default;